import React from "react"
import { Container } from "react-bootstrap"
import MeetingCard from '../components/meetingCard'
import CardButton from '../components/cardButton'
import LivestreamEmbed from '../components/livestreamEmbed'
//import image1 from '../images/01a.jpg'
//import image3 from '../images/03a.jpg'
import imgKulturwerke from '../images/kulturwerke-quer.png'
import Layout from "../components/layout"
import SEO from "../components/seo"
//import Masthead from '../components/masthead'



const ProgrammPage = () => (
  <Layout pageInfo={{ pageName: "programm" }}>
    <SEO title="Home" keywords={[`schueleraustausch`, `meetup`]} />
    <section className="masthead text-white">
      <div className="masthead-content">
        <section id="top">
          <Container>
            <div className="row align-items-start">
              <div className="col-lg-6">
                <div className="p-5">
                  <h3 className="display-4">11:00 – 12:00 Uhr</h3>
                  <p>
                    Unser YouTube Livestream für dich.
                    Dort führen wir dich durch die Planung deines Auslandsjahrs und beantworten die
                    wichtigsten Fragen.
                  </p>

                  <ul className="mb-4">
                    <li>Was machen die X-CHANGE Community und Schueleraustausch.net?</li>
                    <li>Die Planung des eigenen Schüleraustauschs in 5 Schritten</li>
                    <li>Einblicke in die Welt des Auslandsjahrs I</li>
                    <li>Einblicke in die Welt des Auslandsjahrs II</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="p-5 d-flex d-sm-block flex-column align-items-center">
                  {/*<LivestreamEmbed />*/}
                </div>
              </div>
            </div>
          </Container>
        </section>

        <section>
          <Container>
            <div className="row align-items-start">
              <div className="col-lg-6">
                <div className="p-5">
                  <h3 className="display-4">11:00 – 15:00 Uhr</h3>
                  <p>
                    <strong>
                      Nice to meet you | Fragerunde mit Austauschorganisation
                    </strong>
                  </p>
                  <p>
                    Du hast die Chance direkt mit Anna und Matthias von Kulturwerke Deutschland zu sprechen.
                    Sie freuen sich dir unverbindlich
                    und kostenlos alle deine Fragen zum Schüleraustausch in USA, Kanada, Australien,
                    Neuseeland oder England zu beantworten.<br/>
                    Hier ein Paar Ideen, worüber ihr sprechen könntet:
                  </p>
                  <ul className="">
                    <li>Fragen zur Finanzierung, Bewerbung, Visum, Gastfamilie</li>
                    <li>Voraussetzungen für ein Auslandsjahr</li>
                    <li>Schüleraustausch in Zeiten von Corona</li>
                  </ul>
                  <p className="mb-5">
                    Tritt ganz einfach dem Zoom Meeting bei und los geht’s.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="px-5 pb-5">
                  <div className="mb-5">
                    <MeetingCard title="Fragerunde Austauschorganisation">
                      <figure className="p-4">
                        <img src={imgKulturwerke}
                             className="img-fluid"
                             alt="Kulturwerke Logo"
                             style={ { filter: "grayscale(1) invert()" } } />
                      </figure>
                      <p>Anna und Matthias</p>
                      <CardButton href="https://us02web.zoom.us/j/84283950814">
                        Meeting beitreten
                      </CardButton>
                      <p className="mt-4 small">
                        In jedem Fall kannst du dir einen Katalog von Kulturwerke Deutschland <a href="https://www.schueleraustausch.net/apps/catalog_order?organisation_id=kulturwerke&redirect_uri=https%3A%2F%2Fwww.schueleraustausch.net%2Fx-change-meetup-2020%2F">
                        nach Hause bestellen</a>.
                      </p>
                    </MeetingCard>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>

        <section>
          <Container>
            <div className="row align-items-start">
              <div className="col-lg-6">
                <div className="p-5">
                  <h3 className="display-4">12:00 – 13:00 Uhr</h3>
                  <p>
                    <strong>
                      Nice to meet you, too | Storytime und Fragerunde mit YouTuber/-innen
                    </strong>
                  </p>
                  <p>
                    Deine Lieblings-YouTuberInnen waren in unterschiedlichen Ländern im Austausch. Du hast die Chance direkt mit ihnen ins Gespräch zu kommen.<br/>
                    Tritt ganz einfach einem der Meetings die dich interessieren bei und wechsle bei Bedarf.
                  </p>
                  <p>Hier das Programm im Überblick:</p>
                  <ul>
                    <li>Deine Fragen an uns!</li>
                    <li>Weiterer Austausch über Auslandsjahr-Erfahrungen.</li>
                    <li>Wie werde ich Teil der X-CHANGE Community?</li>
                    <li>Verabschiedung</li>
                  </ul>
                  <p className="mb-5">
                    Dieser Austausch findet über <a className="text-white text-decoration-underline" href="#zoom-meeting-kurzanleitung">Zoom-Meetings</a> statt.
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="px-5 pb-5">
                  <div className="mb-5">
                    <MeetingCard title="Kanada / USA">
                      <p>
                        Helene, Paulina, Sima
                      </p>
                      <CardButton href="https://zoom.us/j/93670980952">
                        Meeting beitreten
                      </CardButton>
                    </MeetingCard>
                  </div>
                  <div className="mb-5">
                    <MeetingCard title="Australien / USA">
                      <p>
                        Jolina & Diana
                      </p>
                      <CardButton href="https://zoom.us/j/94288226514">
                        Meeting beitreten
                      </CardButton>
                    </MeetingCard>
                  </div>
                  <div className="mb-5">
                    <MeetingCard title="England / USA">
                      <p>
                        Liz, Charlene, Karolina
                      </p>
                      <CardButton href="https://zoom.us/j/98927577067">
                        Meeting beitreten
                      </CardButton>
                    </MeetingCard>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </section>

        <section id="zoom-meeting-kurzanleitung">
          <Container>
            <div className="p-5">
              <h3 className="display-4">Zoom Meeting Kurzanleitung</h3>
              Du benötigst die Softare "Zoom" um an einem Meeting teilzunehmen.
              <ol>
                <li className="my-3">
                  <b>Lade dir Zoom herunter</b><br />
                  Solltest du Zoom auf deinem Computer oder Smartphone noch nicht installiert haben, wirst du
                  beim Klick auf den Teilnahmelink dazu aufgefordert. Gerne kannst du die App auch schon vorab
                  installieren damit es schneller geht.
                  <br />
                  Hier gehts zum <a href="https://zoom.us/download" target="_blank" rel="nofollow, noreferrer" className="text-white text-decoration-underline">Download</a>.
                  Die App findest du auch im <a href="https://apps.apple.com/de/app/zoom-cloud-meetings/id546505307" target="_blank" rel="nofollow, noreferrer" className="text-white text-decoration-underline">App Store</a> oder
                  im <a href="https://play.google.com/store/apps/details?id=us.zoom.videomeetings&hl=de" target="_blank" rel="nofollow, noreferrer" className="text-white text-decoration-underline">
                    Google Play Store
                  </a>.
                </li>
                <li className="my-3">
                  <b>Einem Meeting beitreten</b><br />
                  Dazu einfach hier auf der Seite auf "Meeting beitreten" klicken. Anschließend öffnet sich die Zoom-App,
                  mit der du teilnehmen kannst. Beachte hierzu die angekündigten Zeiten. Du kannst jederzeit das Meeting
                  verlassen oder in ein anderes wechseln.<br />
                  Alle Zoom Meetings für unser Meetup sind oben auf dieser Seite gelistet.
                </li>
                <li className="my-3">
                  <b>Während des Meetings</b><br />
                  Deine Webcam und dein Mikrofon werden während des X-CHANGE Meetups ausgeschaltet sein – sollte dein Mikrofon doch an sein,
                  bitten wir dich beim Betreten des Meetings dieses auf stumm zu stellen, damit das Event nicht gestört wird. Deine Fragen
                  zum Auslandsjahr kannst du während des gesamten Meetups im Chat stellen.
                </li>
              </ol>
              <p>
                <a href="#top" className="text-white text-decoration-underline">Zum Seitenanfang</a>
              </p>
            </div>
          </Container>
        </section>
      </div>
      <div className="bg-circle-1 bg-circle"></div>
      <div className="bg-circle-2 bg-circle"></div>
      <div className="bg-circle-3 bg-circle"></div>
      <div className="bg-circle-4 bg-circle"></div>
    </section>

  </Layout>
)

export default ProgrammPage
